import { useQuery } from '@tanstack/react-query';

import { backendApiAuthenticationGetUserOptions } from '@/modules/api/@tanstack/react-query.gen';

export const useUserQuery = () =>
  useQuery({
    ...backendApiAuthenticationGetUserOptions(),
    throwOnError: false,
  });
